
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16.468 28","data-code":"61594","data-tags":"facebook,facebook-f"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.984.187v4.125h-2.453c-1.922 0-2.281.922-2.281 2.25v2.954h4.578l-.61 4.625H10.25V26H5.469V14.14H1.484V9.517H5.47V6.109C5.469 2.156 7.89 0 11.422 0c1.687 0 3.14.125 3.562.187z","fill":"inherit"}})])
          )
        }
      }
    